export enum LoaderActionTypeEnum {
  PlaceBid = 'Place bid',
  PlaceDonation = 'Place donation',
  PlacePurchase = 'Place purchase',
  PlaceRafflePurchase = 'Place raffle purchase',
  PlaceEventTicketPurchase = 'Place event ticket purchase',
  Register = 'Register',
  Verify = 'Verify',
  SendVerification = 'Send verification',
  Login = 'Login',
  LoadRafflePurchases = 'Load raffle purchases',
  LoadEventTicketPackages = 'Load event packages',
  LoadEventTicket = 'Load event ticket',
  LoadEventTicketCheckIns = 'Load event ticket check ins',
  LoadItems = 'Load items',
  LoadSelectedItem = 'Load selected item',
  LoadFavouriteItems = 'Load favourite items',
  LoadCategories = 'Load categories',
  LoadVouchers = 'Load vouchers',
  LoadProfiles = 'Load Profiles',
  LoadProfileItemActivities = 'Load profile item activities',
  LoadProfileItemActivity = 'Load profile item activity',
  LoadSetupIntents = 'Load setup intents',
  AttachPaymentMethod = 'Attach payment method',
  DetachPaymentMethod = 'Detach payment method',
  ConfirmCardPayment = 'Confirm card payment',
  ForgotPassword = 'Forgot password',
  VerifyForgotPassword = 'Verify Forgot password',
  Checkout = 'Checkout',
  LoadInvoice = 'Load Invoice',
  EmailInvoice = 'Email invoice',
  SyncProfile = 'Sync profile',
  ProfileUpdate = 'Profile update',
  EmailVoucher = 'Email voucher',
  CheckProfile = 'Check Profile',
  DispatchItems = 'Dispatch items',
  Auction = 'Load Auction',
  ContactOrganizer = 'Contact organizer',
  LoadVoucher = 'Load voucher',
  RedeemVoucher = 'Redeem voucher',
  ResendSmsVerification = 'Resend SMS verification',
  VerifyNotification = 'Verify Notification',
  CustomerPaymentMethods = 'Customer Payment Methods',
  CreateGiftAidValue = 'Create Gift Aid Value',
  LoadGiftAid = 'Load Gift Aid',
  CreatePaymentIntent = 'Create Payment Intent',
  LoadInfobooth = 'Load Infobooth',
  LoadHubs = 'Load Hubs',
  LoadActivityFeedPosts = 'Load Activity Feed Posts',
  LoadCustomFilterGroups = 'Load custom filter groups',
  EventTicketAction = 'Event ticket action',
}
